import { type DocumentEditor } from "@syncfusion/ej2-react-documenteditor";

export const scrollToLinkedParagraph = (
  documentEditor: DocumentEditor,
  query: URLSearchParams,
) => {
  const endPage = query.get("endPage") ?? query.get("page");
  const startOffset = query.get("startOffset");
  const endOffset = query.get("endOffset");

  if (startOffset && endOffset) {
    documentEditor.selection.select(String(startOffset), String(endOffset));
  } else if (endPage) {
    documentEditor.scrollToPage(Number(endPage));
  }
};
